import axios from 'axios';
import { loadingActions } from '../redux/actions';
import { Store } from '../redux/stores';

export const createChar = async (tableId, char) => {
    Store.dispatch(loadingActions.loadingStart('chars.createChar'));
    try {
        let resp = await axios.post(`${process.env.REACT_APP_HOST}/table/${tableId}/char`, {
            "name": char.name,
            "avatar": char.avatar,
            "playerId": char.playerId,
            "redMax": char.redMax,
            "redCurrent": char.redCurrent,
            "redVisibility": char.redVisibility,
            "blueMax": char.blueMax,
            "blueCurrent": char.blueCurrent,
            "blueVisibility": char.blueVisibility,
            "greenMax": char.greenMax,
            "greenCurrent": char.greenCurrent,
            "greenVisibility": char.greenVisibility,
            "sizeX": char.sizeX,
            "sizeY": char.sizeY,
            "bio": char.bio,
            "notes": char.notes,
            "abilities": char.abilities,
            "tags": char.tags,
        });
        Store.dispatch(loadingActions.loadingEnd('chars.createChar'));

        return resp.data.payload;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('chars.createChar'));
        return e.response.data;
    }
};

export const listChars = async (tableId) => {
    Store.dispatch(loadingActions.loadingStart('chars.listChars'));
    const defaultReposne = {status:'error', payload: {cahrs:[]}};
    try {
        let resp = await axios.get(`${process.env.REACT_APP_HOST}/table/${tableId}/chars`);
        Store.dispatch(loadingActions.loadingEnd('chars.listChars'));
        return resp && resp.data && resp.data.payload ? resp.data.payload : defaultReposne;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('chars.listChars'));
        return typeof e.response !== 'undefined' ? e.response.data : defaultReposne;
    }
};

export const updateChar = async (tableId, char) => {
    Store.dispatch(loadingActions.loadingStart('chars.updateChar'));

    try {
        
        let resp = await axios.put(`${process.env.REACT_APP_HOST}/table/${tableId}/char/${char.id}`, {
            "name": char.name || null,
            "hideName": String(char.hideName) || 'false',
            "avatar": char.avatar || null,
            "playerId": char.playerId || null,
            "playerName": char.playerName || null,
            "redMax": char.redMax || null,
            "redCurrent": char.redCurrent || null,
            "redVisibility": char.redVisibility || null,
            "blueMax": char.blueMax || null,
            "blueCurrent": char.blueCurrent || null,
            "blueVisibility": char.blueVisibility || null,
            "greenMax": char.greenMax || null,
            "greenCurrent": char.greenCurrent || null,
            "greenVisibility": char.greenVisibility || null,
            "sizeX": parseInt(char.sizeX) || null,
            "sizeY": parseInt(char.sizeY) || null,
            "bio": char.bio || null,
            "notes": char.notes || null,
            "abilities": char.abilities || null,
            "tags": char.tags ? char.tags.trim() : null,
        });
        Store.dispatch(loadingActions.loadingEnd('chars.updateChar'));

        return resp.data.payload;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('chars.updateChar'));
        return e.response.data;
    }
};

export const removeChar = async (tableId, charId) => {
    Store.dispatch(loadingActions.loadingStart('chars.removeChar'));
    try {
        let resp = await axios.delete(`${process.env.REACT_APP_HOST}/table/${tableId}/char/${charId}`);
        Store.dispatch(loadingActions.loadingEnd('chars.removeChar'));
        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('chars.removeChar'));
        return e.response.data;
    }
};

export const removeMultiChar = async (tableId, charIds) => {
    Store.dispatch(loadingActions.loadingStart('chars.removeMultiChar'));
    try {
        let resp = await axios.delete(`${process.env.REACT_APP_HOST}/table/${tableId}/removeMultiChar/`, {
            data: {
                ids: charIds ?? []
            }
        });
        Store.dispatch(loadingActions.loadingEnd('chars.removeMultiChar'));
        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('chars.removeMultiChar'));
        return e.response.data;
    }
};

export const duplicateChar = async (tableId, charId, qtd) => {
    Store.dispatch(loadingActions.loadingStart('chars.copyChar'));
    try {
        let resp = await axios.post(`${process.env.REACT_APP_HOST}/table/${tableId}/char/${charId}/copy`, {qtd});
        Store.dispatch(loadingActions.loadingEnd('chars.copyChar'));
        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('chars.copyChar'));
        return e.response.data;
    }
};

export const getChar = async (tableId, charId) => {
    Store.dispatch(loadingActions.loadingStart('chars.getChar'));
    try {
        let resp = await axios.get(`${process.env.REACT_APP_HOST}/table/${tableId}/char/${charId}`);
        Store.dispatch(loadingActions.loadingEnd('chars.getChar'));
        return resp.data.payload;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('chars.getChar'));
        return e.response.data;
    }
};

export const getSheet = async (tableId, charId, templateId) => {
    Store.dispatch(loadingActions.loadingStart('chars.getSheet'));
    try {
        let resp = await axios.get(`${process.env.REACT_APP_HOST}/table/${tableId}/char/${charId}/sheet/${templateId}`);
        console.log(resp);
        Store.dispatch(loadingActions.loadingEnd('chars.getSheet'));
        return resp.data.payload;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('chars.getSheet'));
        return e.response.data;
    }
};

export const getSheetAsPromise = async (tableId, charId, templateId) => {
    Store.dispatch(loadingActions.loadingStart('chars.getSheet'));
    let res = axios.get(`${process.env.REACT_APP_HOST}/table/${tableId}/char/${charId}/sheet/${templateId}`);

    res.then((resp) => {
        Store.dispatch(loadingActions.loadingEnd('chars.getSheet'));
        return new Promise((resolve, reject) => {
            resolve(resp.data.payload);
        });
    }).catch((err)=> {
        Store.dispatch(loadingActions.loadingEnd('chars.getSheet'));
        return new Promise((resolve, reject) => {
            reject(err.response.data);
        });
    });

    return res;
};

export const saveSheet = async (tableId, charId, templateId, sheetContent) => {
    Store.dispatch(loadingActions.loadingStart('chars.saveSheet'));
    try {
        let resp = await axios.post(`${process.env.REACT_APP_HOST}/table/${tableId}/char/${charId}/sheet/${templateId}`, {
            values: sheetContent
        });
        Store.dispatch(loadingActions.loadingEnd('chars.saveSheet'));
        return resp.data.payload;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('chars.saveSheet'));
        return e.response.data;
    }
};
